<template>
    <div v-if="loading">
        <v-btn :color=color @click="$emit('click');" disabled>
            {{title}}<v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-btn>
    </div>
    <div v-else>
        <v-btn :color=color @click="$emit('click');">{{title}}</v-btn>
    </div>
</template>
<script>


export default {
  props: ['value','title','color'],
  
  computed: {
    loading() {
       return this.value;
    }
  },
  
};
</script>